export class ModalConfig<T = any> {
  data?: T;
}
